import React, { Component } from 'react';
import Alert from 'react-bootstrap/Alert';
import { connect } from 'react-redux';
import { hideAlert } from '../../redux/actions/alert';

class AppAlert extends Component {

    render() {
        const { type, text } = this.props.alert;
        return (
            text &&
            <div className="alert-wrapper">
                <Alert
                    variant={type}
                    dismissible
                    onClose={this.props.hideAlert}
                >{ text }</Alert>
            </div>
        );
    }
}

export default connect(
    state => ({
        alert: state.alert,
    }),
    {
        hideAlert
    }
)(AppAlert);